import React, { Fragment, useEffect, useState } from "react";
import EAFlyByButton from "../../EAFlyByButton";
import WiedervorlageEditDialog from "./WiedervorlageEditDialog";
import usePathParam from "../../../utils/usePathParam";
import { NUMBER } from "../../../utils/URLUtils";
import { handleApiException, useHttp } from "../../../services/HttpService";
import { getWiedervorlageForBescheidEndpoint, postWiedervorlageForBescheidEndpoint } from "../../../services/BescheidsService";
import { getWiedervorlageForMessstellleEndpoint, postWiedervorlageForMessstelleEndpoint } from "../../../services/Messstellenservice";
import { getWiedervorlageForAnlageEndpoint, postWiedervorlageForAnlageEndpoint } from "../../../services/AnlagenService";
import { getWiedervorlageForBetriebEndpoint, postWiedervorlageForBetriebEndpoint } from "../../../services/BetriebeService";
import { deleteWiedervorlageEndpoint } from "../../../services/WiedervorlagenService";
import { toast } from "react-toastify";

export default function WiedervorlageFlyByButton() {
    const [wiedervorlageDlgOpen, setWiedervorlageDlgOpen] = useState(false);
    const [logo, setLogo] = useState("");
    const betriebsId = usePathParam("id", NUMBER);
    const anlageId = usePathParam("anlageid", NUMBER);
    const messstelleId = usePathParam("messstellenid", NUMBER);
    const bescheidsId = usePathParam("bescheidsid", NUMBER);
    const [fetchUrl, setFetchUrl] = useState("");
    const [saveUrl, setSaveUrl] = useState("");
    const [{ data: currentWiedervorlage, loading }, fetchWiedervorlage] = useHttp(fetchUrl, { manual: !fetchUrl });
    const [{ loading: deleteLoading }, deleteWiedervorlage] = useHttp({ method: "DELETE" }, { manual: true });

    useEffect(() => {
        if (bescheidsId) {
            setFetchUrl(getWiedervorlageForBescheidEndpoint(bescheidsId));
            setSaveUrl(postWiedervorlageForBescheidEndpoint(bescheidsId));
        } else if (messstelleId) {
            setFetchUrl(getWiedervorlageForMessstellleEndpoint(messstelleId));
            setSaveUrl(postWiedervorlageForMessstelleEndpoint(messstelleId));
        } else if (anlageId) {
            setFetchUrl(getWiedervorlageForAnlageEndpoint(anlageId));
            setSaveUrl(postWiedervorlageForAnlageEndpoint(anlageId));
        } else if (betriebsId) {
            setFetchUrl(getWiedervorlageForBetriebEndpoint(betriebsId));
            setSaveUrl(postWiedervorlageForBetriebEndpoint(betriebsId));
        }
    }, [betriebsId, anlageId, messstelleId, bescheidsId, fetchWiedervorlage]);

    useEffect(() => {
        setLogo(currentWiedervorlage ? "ico-wiedervorlage-vorhanden" : "ico-no-reminder-small");
    }, [currentWiedervorlage]);

    function handleWiedervorlageDlgClose(isChanged) {
        if (isChanged) {
            if (currentWiedervorlage?.id) {
                deleteWiedervorlage(deleteWiedervorlageEndpoint(currentWiedervorlage.id))
                    .then(() => {
                        toast.success("Die Wiedervorlage wurde erfolgreich gelöscht.");
                        fetchWiedervorlage().catch((e) => handleApiException(e, "Error fetching Wiedervorlage"));
                    })
                    .catch((e) => handleApiException(e, "Error deleting Wiedervorlage"));
            } else {
                fetchWiedervorlage().catch((e) => handleApiException(e, "Error fetching Wiedervorlage"));
            }
        }
        setWiedervorlageDlgOpen(false);
    }

    return (
        <Fragment>
            <WiedervorlageEditDialog
                open={wiedervorlageDlgOpen}
                onClose={handleWiedervorlageDlgClose}
                saveUrl={saveUrl}
                wiedervorlage={currentWiedervorlage ? currentWiedervorlage : {}}
            />
            <EAFlyByButton
                loading={loading || deleteLoading}
                iconName={logo}
                id="wiedervorlageButton"
                label={currentWiedervorlage ? "Wiedervorlage ansehen" : "Wiedervorlage erstellen"}
                onClick={() => setWiedervorlageDlgOpen(true)}
            />
        </Fragment>
    );
}
